export default {
  defaultTitle: '众悦出行管理平台',
  title: function (title) {
    title = title ? title + ' - ' + this.defaultTitle : this.defaultTitle
    window.document.title = title
  },
  level: function (router_name, menus) {
    let levelState = false
    for (var key in menus) {
        if(menus[key].router == router_name)
            levelState = true
    }

    return levelState
  }
}



// WEBPACK FOOTER //
// ./src/libs/util.js